var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8710_17059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.710686 14.5706C2.51116 13.4828 2.62248 10.9122 0.922784 9.67286L0.616241 9.44934C0.229003 9.16698 -1.10739e-07 8.71658 -1.31688e-07 8.23733L-1.31688e-07 5.25C-2.04111e-07 3.59315 1.34315 2.25 3 2.25L21 2.25C22.6569 2.25 24 3.59315 24 5.25L24 8.23733C24 8.71658 23.771 9.16698 23.3838 9.44934L23.0772 9.67286C21.3775 10.9122 21.4888 13.4828 23.2893 14.5706C23.7304 14.8371 24 15.315 24 15.8303L24 18.75C24 20.4069 22.6569 21.75 21 21.75L3 21.75C1.34315 21.75 -5.87108e-08 20.4069 -1.31134e-07 18.75L2.00212e-07 15.8303C1.77685e-07 15.315 0.269574 14.8371 0.710686 14.5706ZM21 4.5L3 4.5C2.58579 4.5 2.25 4.83579 2.25 5.25L2.25 7.856C5.12435 9.95345 5.06117 14.2094 2.25 16.2474L2.25 18.75C2.25 19.1642 2.58579 19.5 3 19.5L21 19.5C21.4142 19.5 21.75 19.1642 21.75 18.75L21.75 16.2474C18.9388 14.2094 18.8757 9.95345 21.75 7.856L21.75 5.25C21.75 4.83579 21.4142 4.5 21 4.5Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80854 16.291C7.43103 15.9135 7.43103 15.3014 7.80854 14.9239L14.9267 7.80568C15.3042 7.42817 15.9163 7.42817 16.2938 7.80568C16.6713 8.18319 16.6713 8.79526 16.2938 9.17277L9.17563 16.291C8.79812 16.6685 8.18605 16.6685 7.80854 16.291Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.625 10.125C9.03921 10.125 9.375 9.78921 9.375 9.375C9.375 8.96079 9.03921 8.625 8.625 8.625C8.21079 8.625 7.875 8.96079 7.875 9.375C7.875 9.78921 8.21079 10.125 8.625 10.125ZM8.625 11.625C9.86764 11.625 10.875 10.6176 10.875 9.375C10.875 8.13236 9.86764 7.125 8.625 7.125C7.38236 7.125 6.375 8.13236 6.375 9.375C6.375 10.6176 7.38236 11.625 8.625 11.625Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.375 15.375C15.7892 15.375 16.125 15.0392 16.125 14.625C16.125 14.2108 15.7892 13.875 15.375 13.875C14.9608 13.875 14.625 14.2108 14.625 14.625C14.625 15.0392 14.9608 15.375 15.375 15.375ZM15.375 16.875C16.6176 16.875 17.625 15.8676 17.625 14.625C17.625 13.3824 16.6176 12.375 15.375 12.375C14.1324 12.375 13.125 13.3824 13.125 14.625C13.125 15.8676 14.1324 16.875 15.375 16.875Z",
    fill: "#C2C2C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8710_17059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountSetting);
export default __webpack_public_path__ + "static/media/discount-setting.f5e417f309bcfe320a4e2cb2be511806.svg";
export { ForwardRef as ReactComponent };